import React from 'react';
import { useCart } from '../context/CartContext';
export function Fabric() {
  const {
    addToCart
  } = useCart();
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-533">
      <div className="max-w-[1800px] mx-auto" data-id="element-534">
        <header className="mb-20 text-center" data-id="element-535">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-black/40" data-id="element-536">
            The Raw Material
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-537">
            Fabric
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-538">
            Authentic hand-woven Kente, Ankara prints, and luxury silks by the
            yard.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-1" data-id="element-539">
          <div className="aspect-video bg-grey-divider overflow-hidden relative group" data-id="element-540">
            <img src="https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&q=80&w=1200" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Fabric" data-id="element-541" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-542">
              <button onClick={() => addToCart({
              id: 'fabric-kente-yard',
              name: 'Hand-woven Kente (per yard)',
              price: '$85.00',
              image: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&q=80&w=1200',
              quantity: 1,
              size: '1 Yard'
            })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-543">
                Add to Bag
              </button>
            </div>
          </div>
          <div className="md:hidden px-2 mb-8 flex justify-between items-center" data-id="element-544">
            <span className="text-xs md:text-sm font-display font-bold uppercase tracking-widest" data-id="element-545">
              Hand-woven Kente
            </span>
            <button onClick={() => addToCart({
            id: 'fabric-kente-yard',
            name: 'Hand-woven Kente (per yard)',
            price: '$85.00',
            image: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&q=80&w=1200',
            quantity: 1,
            size: '1 Yard'
          })} className="text-xs font-display font-bold uppercase tracking-widest border-b border-black" data-id="element-546">
              Add to Bag
            </button>
          </div>
          <div className="aspect-video bg-grey-divider overflow-hidden relative group" data-id="element-547">
            <img src="https://images.unsplash.com/photo-1598554747436-c9293d6a588f?auto=format&fit=crop&q=80&w=1200" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Fabric" data-id="element-548" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-549">
              <button onClick={() => addToCart({
              id: 'fabric-silk-yard',
              name: 'Luxury Silk (per yard)',
              price: '$65.00',
              image: 'https://images.unsplash.com/photo-1598554747436-c9293d6a588f?auto=format&fit=crop&q=80&w=1200',
              quantity: 1,
              size: '1 Yard'
            })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-550">
                Add to Bag
              </button>
            </div>
          </div>
          <div className="md:hidden px-2 mb-8 flex justify-between items-center" data-id="element-551">
            <span className="text-xs md:text-sm font-display font-bold uppercase tracking-widest" data-id="element-552">
              Luxury Silk
            </span>
            <button onClick={() => addToCart({
            id: 'fabric-silk-yard',
            name: 'Luxury Silk (per yard)',
            price: '$65.00',
            image: 'https://images.unsplash.com/photo-1598554747436-c9293d6a588f?auto=format&fit=crop&q=80&w=1200',
            quantity: 1,
            size: '1 Yard'
          })} className="text-xs font-display font-bold uppercase tracking-widest border-b border-black" data-id="element-553">
              Add to Bag
            </button>
          </div>
        </div>
      </div>
    </div>;
}